import { FC, useContext, useState } from 'react';

import { Table, ContextMenu, useContextMenu } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LayoutContext } from 'components/Layout';
import { useCategoryRequests, useContextMenuItemsCategory } from 'hooks';
import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';
import { TGroup } from 'types';

import { IGoodsGroupTableProps } from '../interfaces';
import s from './GoodsGroupTable.module.scss';
import { useColumns } from './useColumns';

export const GoodsGroupTable: FC<IGoodsGroupTableProps> = ({
  loadedCategories,
  editGroup,
  deleteCategory,
  updateCategory,
  setIsDeletingError,
  loadingTable,
}) => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: { shellGoodsDisplayEnabled },
    },
  } = useContext(SettingsContext);
  const layoutElement = useContext(LayoutContext);
  const [selectedCategory, setSelectedCategory] = useState<TGroup | null>(null);

  const { toggleShowInShellCategory } = useCategoryRequests({
    setIsDeletingError,
  });
  const contextMenuItems = useContextMenuItemsCategory({
    show_in_shell: selectedCategory?.show_in_shell || false,
    deleteCategory,
    updateCategory,
    editGroup,
    toggleShowInShellCategory,
  });
  const {
    contextMenuData,
    closeContextMenu,
    onContextMenu,
    cursorPosition,
    onTouchEnd,
    onTouchMove,
    onTouchStart,
  } = useContextMenu<TGroup>();

  const columns = useColumns({ toggleShowInShellCategory });

  return (
    <div className={s.wrapper}>
      {contextMenuData && cursorPosition && (
        <ContextMenu
          layoutElement={layoutElement}
          data={contextMenuData}
          items={contextMenuItems}
          closeContextMenu={closeContextMenu}
          position={cursorPosition}
        />
      )}
      <Table
        isLoading={loadingTable}
        onRowClick={(event, row) => {
          setSelectedCategory(row.original);
        }}
        data={loadedCategories}
        columns={columns}
        className={cn(s.table, s.last_cell)}
        onContextMenu={(e) => {
          selectedCategory && onContextMenu(e, selectedCategory);
        }}
        onRowDoubleClick={(_, row) => editGroup(row)}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        emptyDataPlaceholder={t('group.table.empty.placeholder')}
        hiddenColumns={!shellGoodsDisplayEnabled ? ['show_in_shell'] : []}
      />
    </div>
  );
};
